import { Fancybox } from '@fancyapps/ui'
import { Splide } from '@splidejs/splide';
// import { init } from "shareon";

// init();
// Add .animated to elements with .animate when they enter the viewport
document.addEventListener('DOMContentLoaded', () => {
	const observer = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('animated');
					observer.unobserve(entry.target);
				}
			});
		},
		{
			rootMargin: '-35% 0px',
			threshold: 0.01
		}
	);

	document.querySelectorAll('main .animate').forEach(el => {
		observer.observe(el);
	});
});

// Splide
if (document.querySelector('.splide')) {

	document.querySelectorAll('.services--section').forEach((slider) => {
		const section = slider.closest('section');

		const splide = new Splide(slider, {
			type: 'loop',
			drag: 'free',
			snap: true,
			perPage: 3,
			perMove: 1,
			gap: '32px',
			trimSpace: false,
			padding: { right: '8%' },

			breakpoints: {
				991: {
					perPage: 2,
					padding: { right: '10%' },
				},
				576: {
					perPage: 1,
					padding: { right: '0' },
				},
			},
		});

		const movePagination = () => {
			const pagination = splide.root.querySelector('.splide__pagination');
			const target = section?.querySelector('.custom-pagination');

			if (pagination && target && pagination.parentNode !== target) {
				target.appendChild(pagination);
			}
		};

		splide.on('mounted', movePagination);
		splide.on('pagination:updated', movePagination);
		splide.on('updated', movePagination);
		splide.on('resized', movePagination);

		splide.mount();

		section
			?.querySelector('.services-btn-prev')
			?.addEventListener('click', () => splide.go('<'));

		section
			?.querySelector('.services-btn-next')
			?.addEventListener('click', () => splide.go('>'));
	});

	document.querySelectorAll('.testimonial--section').forEach((slider) => {
		const section = slider.closest('section');

		const splide = new Splide(slider, {
			type: 'loop',
			drag: 'free',
			snap: true,
			perPage: 3,
			perMove: 1,
			gap: '32px',
			trimSpace: false,
			padding: { right: '8%' },

			breakpoints: {
				991: {
					perPage: 2,
					padding: { right: '10%' },
				},
				576: {
					perPage: 1,
					padding: { right: '0' },
				},
			},
		});

		const movePagination = () => {
			const pagination = splide.root.querySelector('.splide__pagination');
			const target = section?.querySelector('.custom-pagination');

			if (pagination && target && pagination.parentNode !== target) {
				target.appendChild(pagination);
			}
		};

		splide.on('mounted', movePagination);
		splide.on('pagination:updated', movePagination);
		splide.on('updated', movePagination);
		splide.on('resized', movePagination);

		splide.mount();

		section
			?.querySelector('.testimonial-btn-prev')
			?.addEventListener('click', () => splide.go('<'));

		section
			?.querySelector('.testimonial-btn-next')
			?.addEventListener('click', () => splide.go('>'));
	});

	document.querySelectorAll('.property--section').forEach((slider) => {
		const section = slider.closest('section');

		const splide = new Splide(slider, {
			type: 'loop',
			drag: 'free',
			snap: true,
			perPage: 3,
			perMove: 1,
			gap: '32px',
			trimSpace: false,
			padding: { right: '8%' },

			breakpoints: {
				991: {
					perPage: 2,
					padding: { right: '10%' },
				},
				576: {
					perPage: 1,
					padding: { right: '0' },
				},
			},
		});

		const movePagination = () => {
			const pagination = splide.root.querySelector('.splide__pagination');
			const target = section?.querySelector('.custom-pagination');

			if (pagination && target && pagination.parentNode !== target) {
				target.appendChild(pagination);
			}
		};

		splide.on('mounted', movePagination);
		splide.on('pagination:updated', movePagination);
		splide.on('updated', movePagination);
		splide.on('resized', movePagination);

		splide.mount();

		section
			?.querySelector('.property-btn-prev')
			?.addEventListener('click', () => splide.go('<'));

		section
			?.querySelector('.property-btn-next')
			?.addEventListener('click', () => splide.go('>'));
	});
	document.querySelectorAll('.post--section').forEach((slider) => {
		const section = slider.closest('section');

		const splide = new Splide(slider, {
			type: 'slide',
			drag: 'free',
			snap: true,
			perPage: 3,
			perMove: 1,
			gap: '32px',
			trimSpace: false,
			padding: { right: '8%' },

			breakpoints: {
				991: {
					perPage: 2,
					padding: { right: '10%' },
				},
				576: {
					perPage: 1,
					padding: { right: '0' },
				},
			},
		});

		const movePagination = () => {
			const pagination = splide.root.querySelector('.splide__pagination');
			const target = section?.querySelector('.custom-pagination');

			if (pagination && target && pagination.parentNode !== target) {
				target.appendChild(pagination);
			}
		};

		splide.on('mounted', movePagination);
		splide.on('pagination:updated', movePagination);
		splide.on('updated', movePagination);
		splide.on('resized', movePagination);

		splide.mount();

		section
			?.querySelector('.post-btn-prev')
			?.addEventListener('click', () => splide.go('<'));

		section
			?.querySelector('.post-btn-next')
			?.addEventListener('click', () => splide.go('>'));
	});
}



/**
 * Once the page loads, do our stuff!
 */
document.addEventListener('DOMContentLoaded', function () {
	// Get Fancybox going.
	Fancybox.bind('[data-fancybox]', {});

	const mobileNav = document.getElementById('mobile-nav');
	const toggler = document.querySelector('.navbar-toggler');

	if (!mobileNav || !toggler) return;

	mobileNav.addEventListener('show.bs.offcanvas', () => {
		toggler.classList.add('is-active');
		document.body.classList.add('mobile-menu-open');
	});

	mobileNav.addEventListener('hidden.bs.offcanvas', () => {
		toggler.classList.remove('is-active');
		document.body.classList.remove('mobile-menu-open');
	});
});